<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4" style="min-width: 35vw">
            <CCardBody>
              <img src="/img/logo.png" width="180">
              <CForm @submit.prevent="login" method="POST">
                <h1>S'identifier</h1>
                <p class="text-muted">Connectez-vous à votre compte</p>
                <CInput
                  v-model="email"
                  prependHtml="<i class='cui-user'></i>"
                  placeholder="Email"
                  autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  v-model="password"
                  prependHtml="<i class='cui-lock-locked'></i>"
                  placeholder="Mot de passe"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="12" class="text-right">
                    <CButton color="link" class="px-0">Mot de passe oublié?</CButton>
                  </CCol>
                  <CCol col="12" class="text-left">
                    <CButton type="submit" color="primary" class="px-4 w-100" style=" background: #ef86c1; border-color: #ef86c1; ">S'identifier</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>

import axios from "axios";

    export default {
      name: 'Login',
      data() {
        return {
          email: '',
          password: '',
          showMessage: false,
          message: '',
        }
      },
      methods: {
        goRegister(){
          this.$router.push({ path: 'register' });
        },
        login() {
          let self = this;
          this.loader = this.$loading.show();

          axios.post(  this.$apiAdress + '/api/login', {
            email: self.email,
            password: self.password,
          }).then(function (response) {
            self.email = '';
            self.password = '';
            localStorage.setItem("_token", response.data.token);
            localStorage.setItem('roles', response.data.user.menuroles);
            self.$router.push({ path: 'dashboard' });
          })
          .catch(function (error) {
            self.$toast.error('Connection impossible! Incorrect E-mail or password');
            self.message = 'Incorrect E-mail or password';
            self.showMessage = true;
            console.log(error);
          })
          .finally(function(){
            self.loader.hide();
          });
  
        }
      }
    }

</script>
